import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useUserAuth } from '~/components/Auth';
import { URLS } from '../../config/constants';
import messages from '../../messages';
import { FormattedMessage } from 'react-intl';
import StyledKScore, {
  StyledKScorePopover,
  halfStarStyles,
  StyledButtonWithIcon,
  StyledKScoreHeadingWrapper,
} from './style';
import Icon, { ICON_MAP } from '@mindtickle/icon';
import { TEXT_TYPES } from '@mindtickle/styles/lib/classNames';
import Label from '@mindtickle/label';

interface KScorePopoverProps {
  disableParticipants?: boolean;
  kScore?: number;
}

interface CompanySettings {
  disableParticipants?: boolean;
}

interface Company {
  companySettings?: CompanySettings;
}

interface AuthUser {
  kScore?: number;
  company?: Company;
}

const KScorePopover: React.FC<KScorePopoverProps> = ({ disableParticipants }) => {
  const navigate = useNavigate();

  const compareWithPeersHandler = (): void => {
    navigate(URLS.PARTICIPANTS);
  };

  return (
    <>
      <StyledKScoreHeadingWrapper>
        <Label
          type={TEXT_TYPES.HEADING_SMALL}
          tag="h4"
          cssStyles="margin-bottom: 8px"
          message={messages.yourScore}
        />
        <Label type={TEXT_TYPES.LABEL_LARGE_DEFAULT} message={messages.descriptionKScore} />
        {!disableParticipants && (
          <StyledButtonWithIcon
            onClick={compareWithPeersHandler}
            type="primary"
            iconType={ICON_MAP.RIGHT_ARROW2}
          >
            <FormattedMessage {...messages.compareKScore} />
          </StyledButtonWithIcon>
        )}
      </StyledKScoreHeadingWrapper>
    </>
  );
};

const KScore: React.FC = () => {
  const auth = useUserAuth() as AuthUser;
  const {
    kScore = 0,
    company: { companySettings: { disableParticipants = false } = {} } = {},
  } = auth;
  const currentKScore = Math.trunc(kScore / 100);

  return (
    <StyledKScorePopover
      content={<KScorePopover kScore={currentKScore} disableParticipants={disableParticipants} />}
      getPopupContainer={(trigger: HTMLElement) => trigger.parentElement as HTMLElement}
      placement="bottomLeft"
      align={{ targetOffset: [0, -6] }}
    >
      <StyledKScore data-testid="k-score">
        <Icon css={halfStarStyles} type={ICON_MAP.SCORE} />
        <span>{currentKScore}</span>
      </StyledKScore>
    </StyledKScorePopover>
  );
};

export default KScore;
